/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DuePointInvoiceAddendumFromJSON, DuePointInvoiceAddendumToJSON, } from './DuePointInvoiceAddendum';
/**
 * Check if a given object implements the GetAllDueMeteringPointsV1200Response interface.
 */
export function instanceOfGetAllDueMeteringPointsV1200Response(value) {
    if (!('page' in value) || value['page'] === undefined)
        return false;
    if (!('size' in value) || value['size'] === undefined)
        return false;
    if (!('pages' in value) || value['pages'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
export function GetAllDueMeteringPointsV1200ResponseFromJSON(json) {
    return GetAllDueMeteringPointsV1200ResponseFromJSONTyped(json, false);
}
export function GetAllDueMeteringPointsV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'page': json['page'],
        'size': json['size'],
        'pages': json['pages'],
        'total': json['total'],
        'items': (json['items'].map(DuePointInvoiceAddendumFromJSON)),
    };
}
export function GetAllDueMeteringPointsV1200ResponseToJSON(json) {
    return GetAllDueMeteringPointsV1200ResponseToJSONTyped(json, false);
}
export function GetAllDueMeteringPointsV1200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'page': value['page'],
        'size': value['size'],
        'pages': value['pages'],
        'total': value['total'],
        'items': (value['items'].map(DuePointInvoiceAddendumToJSON)),
    };
}
